import { ProductItemComponentType, ProductVariantType, Maybe } from '~/@types/models'
export enum TitleNotePosition {
  BELOW_TITLE,
  IMAGE_BOTTOM,
}

export enum ImageSize {
  FULLSCREEN = 'FULLSCREEN',
  OVERHEAD = 'OVERHEAD',
  FRONT = 'FRONT',
}

export const imageSizeMap = {
  FULLSCREEN: 'productLifestyle',
  OVERHEAD: 'productOverhead',
  FRONT: 'productFront',
}

export interface ProductItemsProps {
  variant?: string
  product: ProductItemComponentType
  visibleVariantsCount?: number
  productImageRatio?: number
  imageSize?: ImageSize
  titleNotePosition?: TitleNotePosition
  productVariant?: Maybe<ProductVariantType>
  collectionHandle?: string
  isNoScaleCustom?: boolean
  imageDimensions?: {
    width: [number, number]
    height: [number, number]
  }
  aspectRatio?: boolean
  showPrice?: boolean
  onlyCompareAtPriceVariants?: boolean
}

export type UseProductLinkType = Pick<ProductItemsProps, 'product' | 'collectionHandle'> & {
  currentVariant?: ProductItemsProps['productVariant']
}
